import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
import { offerAnchor } from '../data/content';
import { recentPurchases } from '../data/purchases';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 12000;
export function PurchasePopup() {
  const [index, setIndex] = useState<number | null>(null);
  useEffect(() => {
    let count = 0;
    let hideTimer: number | undefined;
    let interval: number | undefined;
    const show = () => {
      setIndex(count % recentPurchases.length);
      count += 1;
      hideTimer = window.setTimeout(() => setIndex(null), VISIBLE_FOR);
    };
    const first = window.setTimeout(() => {
      show();
      interval = window.setInterval(show, INTERVAL);
    }, FIRST_DELAY);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, []);
  const purchase = index === null ? null : recentPurchases[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-3 left-3 z-[60] md:bottom-6 md:left-6" data-id="element-207" data-mp="164oa074zg5up">
      <AnimatePresence data-id="element-208" data-mp="116cylrz1hnad">
        {purchase && <motion.a key={index} href={offerAnchor} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[290px] items-center gap-3 rounded-xl border-[3px] border-gold bg-forest p-3 shadow-2xl shadow-charcoal/40" data-id="element-209" data-mp="1fwbwdtmomwpb">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-210" data-mp="s67tjohbj0zd">
              <ShoppingBagIcon className="h-5 w-5 text-charcoal" aria-hidden="true" data-id="element-211" data-mp="28kg2uhd2vdt2" />
            </span>
            <span className="min-w-0 text-left" data-id="element-212" data-mp="23ln0nl38r987">
              <span className="block text-sm font-extrabold leading-tight text-ivory" data-id="element-213" data-mp="23kv4a81tl7gv">
                {purchase.name}{' '}
                <span className="font-semibold text-ivory/80" data-id="element-214" data-mp="2aqnxr6f2wlc7">
                  from {purchase.city}, {purchase.province}, Argentina
                </span>
              </span>
              <span className="mt-0.5 block text-xs text-sand" data-id="element-215" data-mp="2knadjgsjsm7d">
                just purchased Complete Stretching System 2026
              </span>
              <span className="mt-0.5 block text-[10px] font-bold uppercase tracking-wider text-gold" data-id="element-216" data-mp="1rybv0ikiji1j">
                {purchase.time}
              </span>
            </span>
          </motion.a>}
      </AnimatePresence>
    </div>;
}